import DOMPurify from 'dompurify';
// Documents remain server-owned. Only presentation and executable HTML are normalized.
export function documentHTML(content) {
  const fragment = DOMPurify.sanitize(typeof content === 'string' ? content : '', {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['form', 'input', 'button', 'textarea', 'select', 'iframe', 'style'],
    RETURN_DOM_FRAGMENT: true,
  });
  fragment.querySelectorAll('*').forEach((node) => {
    const alignment = node.style.textAlign;
    const weight = node.style.fontWeight;
    const italic = node.style.fontStyle;
    const decoration = node.style.textDecoration;
    const id = node.getAttribute('id');
    const indent = node.className.match?.(/(?:^|\s)ql-indent-([1-8])(?:\s|$)/)?.[1];
    node.removeAttribute('style');
    node.removeAttribute('class');
    if (id) node.id = 'pp-document-' + id;
    if (italic === 'italic') node.style.fontStyle = 'italic';
    if (['underline', 'line-through'].includes(decoration)) node.style.textDecoration = decoration;
    if (['left', 'right', 'center', 'justify'].includes(alignment))
      node.style.textAlign = alignment;
    if (['bold', '600', '700'].includes(weight)) node.style.fontWeight = '600';
    if (indent) node.style.paddingInlineStart = `${Number(indent)}em`;
    if (node.tagName === 'A') {
      node.setAttribute('rel', 'noopener noreferrer');
      const href = node.getAttribute('href') || '';
      if (href.startsWith('#')) node.setAttribute('href', '#pp-document-' + href.slice(1));
      if (/^https?:\/\//i.test(href)) node.setAttribute('target', '_blank');
      else node.removeAttribute('target');
    }
    if (node.tagName === 'TABLE') {
      const wrapper = document.createElement('div');
      wrapper.className = 'pp-legal-table';
      wrapper.tabIndex = 0;
      node.replaceWith(wrapper);
      wrapper.appendChild(node);
    }
  });
  const container = document.createElement('div');
  container.appendChild(fragment);
  return container.innerHTML;
}
export function hasDocument(html) {
  const el = document.createElement('div');
  el.innerHTML = html;
  return Boolean(el.textContent.replace(/\u00a0/g, ' ').trim() || el.querySelector('img,hr'));
}
